<template>
  <div id="wrapper">
    <Nav :message="message" />
    <SalaryReport />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import SalaryReport from '@/components/dashboard/SalaryReport.vue'

export default {
  name: 'salary-report',
  props: ['message'],
  components: {
    Nav,
    SalaryReport
  }
}
</script>